module.exports = __webpack_public_path__ + "static/img/1.47e94591.png";